var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7803 16.7908C14.4874 17.0697 14.0126 17.0697 13.7197 16.7908L9.21967 12.5051C8.92678 12.2261 8.92678 11.7739 9.21967 11.4949L13.7197 7.20921C14.0126 6.93026 14.4874 6.93026 14.7803 7.20921C15.0732 7.48816 15.0732 7.94042 14.7803 8.21936L10.8107 12L14.7803 15.7806C15.0732 16.0596 15.0732 16.5118 14.7803 16.7908Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackIcon);
export default __webpack_public_path__ + "static/media/BackIcon.6272c90e1c34ec8bb13d2d95061856ca.svg";
export { ForwardRef as ReactComponent };